import type { GlucoseActivity } from "src/types"

export const defaultGlucoseActivity: GlucoseActivity = {
  mg_dl: 0,
}
